export interface UserBaseDto {
  firstName: string;
  lastName: string;
  username: string;
  email: string;
  initials: string;
  active: boolean;
  keycloakId: string;
}

export interface UserDto extends UserBaseDto {
  id: number;
}

export interface CurrentUserDto extends UserBaseDto {
  id: number;
  roles: string[];
}

export enum UserRole {
  Admin = 'admin',
  Basic = 'basic'
}
